module.exports = __webpack_public_path__ + "static/c515c6fc149bf57c91b7981d057aee2af380ec32ea9d12bebf190a0b2a18417d-656186ebe1eaf9d04cf6fbf2942ca308.png";